import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import './_Accordion.scss';

const Accordion = ({ children, title }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className='accordion'>
      <div className='accordion-hero' onClick={() => setOpen(!open)}>
        <span>{title}</span>
        <Icon name={!open ? 'arrow down' : 'arrow up'} />
      </div>
      <>
        {open
          && (
            <>
              {children}
            </>
          )}
      </>
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
};

export default Accordion;
